module.exports = __webpack_public_path__ + "static/feature-2-4f761a91abbbf4b66de4a48e43865974.svg";